<template>
  <flex-layout class="p-1 container" justify="center">
    <base-form v-model="validForm" class="col-12 col-md-11 col-sm-11 col-lg-8">
      <flex-layout v-if="!breakPoint.xs" class="mt-5" justify="between" wrap>
        <base-title color="primary"  size="sm"  style="font-weight: 700;" >新規会員登録</base-title>
        <div class="d-flex justify-content-end">
         <base-text color="primary" size="md" class="mt-2 mt-md-0 align-self-center" >登録済みの方は</base-text>
         <base-button class="mt-2 mt-md-0" size="sm" @click="router.push({name: 'Login'})">ログイン</base-button>
        </div>
      </flex-layout>
      <flex-layout v-else justify="between" wrap>
        <base-title color="primary" size="sm" bold>新規会員登録</base-title>
        <flex-layout class="d-flex justify-content-end" style="width: 100%;">
          <base-text color="primary" size="md" class="mt-3 align-self-end">登録済みの方は</base-text>
          <base-button size="sm" class="mt-3 mt-md-0" @click="router.push({name: 'Login'})" style="line-height: 2; "> <div style="margin-top: 4px;">ログイン</div></base-button>
        </flex-layout>
      </flex-layout>

      <div class="marginTop px-2" >
      <base-title color="primary" class="titleMargins" bold  >お客様情報</base-title>
      </div>
      <base-text class="ps-2 mt-5" size="md" color="primary" required-tag>お名前</base-text>

      <base-text :min-height="0" class="ps-2" size="xs" v-html="`一部の旧字体、異体字、記号等はご使用になれません。`" @click.stop/>

      <name-input v-model:last-name="form.lastName" v-model:first-name="form.firstName" />

      <katakana-name-input v-model:last-name="form.lastNameKana" v-model:first-name="form.firstNameKana" />

      <email-input v-model:email="form.email" />

      <password-input v-model="form.password" placeholder="8～32文字" autocomplete="one-time-code"
                      :rules="[rules.requiredWithLabelName({name: 'パスワード'}), rules.password]" required-tag/>

      <phone-input v-model:tel="form.tel" />

      <address-input v-model:address="form.address" v-model:town="form.town" v-model:city="form.city" v-model:pref="form.pref" v-model:zip-code="form.zipCode" />

      <div class="marginTop marginBottom px-1">
      <base-title color="primary" class="titleMargins" bold >ご希望の条件</base-title>
      </div>
      <flex-layout>
        <base-text class="col-4 col-sm-3 mt-3" size="md" color="primary" required-tag>都道府県</base-text>
        <base-select
            v-model="form.hope.pref"
            :items="hopePrefectures"
            return-object
            no-label
            placeholder="都道府県を選択"
            :clearable="!!form.hope.pref.id"
            item-value="id"
            item-text="name"
            :rules="[rules.requiredWithLabelName({name: '都道府県'})]"
        />
      </flex-layout>
      <flex-layout v-for="(item, i) in form.hope.cities" :key="i" >
        <base-text class="col-4 col-sm-3 mt-3" size="md" color="primary" :required-tag="i === 0">エリア{{ i + 1 }}</base-text>
        <base-select
            class="col-8 col-sm-9"
            v-model="form.hope.cities[i]"
            :items="filterHopeCities(item)"
            :clearable="!!form.hope.cities[i].id"
            no-label
            placeholder="市区町村を選択"
            :rules="i === 0 ? [rules.requiredWithLabelName({ name: '市区町村' })] : []"
            return-object
            item-text="name"
            item-value="id"
        />
      </flex-layout>
      <base-text v-if="atLeastOnePriceSelected()" class="w-100 mb-2" color="error" justify="center">
        物件種別を必ず1つ選択してください
      </base-text>
      <min-max-selector
          v-model="form.hope.newEstatePrice"
          label="新築一戸建て"
          strict
          labelSize="md"
          :check-box-rules="[atLeastOnePriceSelected]"
          @update:modelValue="form.hope.estateType.newEstatePrice = !!$event"
      />
      <min-max-selector
          v-model="form.hope.oldEstatePrice"
          label="中古一戸建て"
          strict
          labelSize="md"
          :check-box-rules="[atLeastOnePriceSelected]"
          @update:modelValue="form.hope.estateType.oldEstatePrice = !!$event"
      />
      <min-max-selector
          v-model="form.hope.newMansionPrice"
          label="新築マンション"
          strict
          labelSize="md"
          :check-box-rules="[atLeastOnePriceSelected]"
          @update:modelValue="form.hope.estateType.newMansionPrice = !!$event"
      />
      <min-max-selector
          v-model="form.hope.oldMansionPrice"
          label="中古マンション"
          labelSize="md"
          strict
          :check-box-rules="[atLeastOnePriceSelected]"
          @update:modelValue="form.hope.estateType.oldMansionPrice = !!$event"
      />
      <min-max-selector
          v-model="form.hope.landPrice"
          label="土地"
          labelSize="md"
          strict
          :check-box-rules="[atLeastOnePriceSelected]"
          @update:modelValue="form.hope.estateType.landPrice = !!$event"
      />
      <min-max-selector
          v-model="form.hope.businessPrice"
          label="事業用"
          strict
          labelSize="md"
          :check-box-rules="[atLeastOnePriceSelected]"
          @update:modelValue="form.hope.estateType.businessPrice = !!$event"
      />

      <hope-select-shop-input class="mt-4 mb-5" v-model="form.shopsStatistics" :items="shopEstateStatistics"
                              :readonly="!!props.encodedFcShopId" :loading="shopEstateStatisticsLoading" />

      <div class="div-relative">
        <div v-show="helper" class="div-absolute tip-content">
          <base-text size="xs" color="primary">「新家便サービス」とはお客様のご希望にあった新着物件情報をいち早くメールでお届けするサービスです。※Gmailの場合受信できない事象が発生しているため、新家便を希望されるお客様はGmail以外のメールアドレスをご登録ください。</base-text>
        </div>
      </div>
      <div class="d-md-flex align-content-center">
        <div class="d-flex align-items-center col-lg-4 col-md-6 col-sm-3 col-xl-3">
          <base-text size="md" color="primary" no-wrap>新家便サービス</base-text>
          <div>
            <base-text
                class="question-btn clickable"
                color="white"
                @click="openHelp"
                size="lg">
              {{ '?' }}
            </base-text>
          </div>
        </div>
        <base-checkbox class="col-12 col-md-9 pa-0" v-model="form.hope.pushShinyabinFlag"
                       label="新家便サービス（新着物件情報のメール）を受け取る"/> <br/>
      </div>
      <div class="d-md-flex align-content-center mt-3">
        <div class="d-flex align-items-center col-lg-4 col-md-6 col-sm-3 col-xl-3">
          <base-text size="md" color="primary" no-wrap>メルマガサービス</base-text>
        </div>
        <base-checkbox class="col-12 col-md-9 pa-0" v-model="form.hope.newstellerFlag"
                       label="メールマガジンの配信を許可する"/> <br/>
      </div>
      <base-link class="mt-8 w-100" justify="center" route="TermsOfUse" new-window hover-underline>利用規約を見る
      </base-link>
      <base-text v-if="translateError" color="error" justify="center">{{ translateError }}</base-text>
      <flex-layout class="mx-auto mt-3" justify="center">
        <base-text v-if="configuration.isInDataPersistenceMaintenance" color="error">
          メンテナンス中のため、しばらくお待ちください
        </base-text>
      </flex-layout>
      <flex-layout class="mx-auto mt-3" justify="center">
        <base-button :loading="registerUserLoading"
                     :disabled="configuration.isInDataPersistenceMaintenance || shopEstateStatisticsLoading " size="lg" @click="sendForm">
          上記に同意し登録する
        </base-button>
      </flex-layout>
    </base-form>
  </flex-layout>
</template>

<script lang="ts" setup>
import {computed, inject, onUnmounted, reactive, ref, watch} from 'vue';
import {useRouter} from 'vue-router';
import {
  useListPrefectures
} from '@/composable/controller/useAddress';
import useUserRegister from '@/composable/controller/auth/useUserRegister';
import {useValidator} from '@/composable/ui/useValidator';
import BaseSelect from '@/components/Forms/BaseSelect.vue';
import MinMaxSelector from '@/components/Forms/MinMaxSelector.vue';
import BaseCheckbox from '@/components/Forms/BaseCheckbox.vue';
import BaseText from '@/components/Texts/BaseText.vue';
import BaseTitle from '@/components/Texts/BaseTitle.vue';
import BaseLink from '@/components/Texts/BaseLink.vue';
import BaseForm from '@/components/Forms/BaseForm.vue';
import {City} from '@/domain/city.entity';
import ApiError from '@/domain/errors/ApiError';
import useErrorTranslate from '@/composable/ui/useErrorTranslate';
import {useBreakpoint} from '@/composable/ui/useScreen';
import PasswordInput from '@/components/Forms/PasswordInput.vue';
import useGetShopsByEncodedId from '@/composable/controller/fcShop/useGetShopsByEncodedId';
import {useGetShopEstateStatistics} from '@/composable/controller/shop/useGetShopStatistics';
import BaseButton from '../../components/Buttons/BaseButton.vue';
import FlexLayout from '../../components/Layouts/FlexLayout.vue';
import useApplicationConfig from '@/composable/controller/application/useApplicationConfig';
import HopeSelectShopInput from '@/views/Hope/components/HopeSelectShopInput.vue';
import {EstateCount} from '@/services/http/fcShop.donetwork.http';
import {Pref} from "@/domain/pref.entity";
import {Town} from "@/domain/town.entity";
import {useForceValidate} from "@/composable/ui/useForm";
import useGoogleTagManager from "@/composable/controller/analytics/useAnalytics";
import KatakanaNameInput from "@/components/Forms/KatakanaNameInput.vue";
import EmailInput from "@/components/Forms/EmailInput.vue";
import NameInput from "@/components/Forms/NameInput.vue";
import PhoneInput from "@/components/Forms/PhoneInput.vue";
import AddressInput from "@/components/Forms/AddressInput.vue";

const {configuration} = useApplicationConfig();
const { forceValidate } = useForceValidate();
const { useAnalytics } = useGoogleTagManager();

interface OptionalRegisterReferralOptions {
  encodedFcShopId?: string,
  fcShopReferralCode?: string,
  analyticsCode?: string,
}

const defaultForm = {
  lastName: '',
  firstName: '',
  lastNameKana: '',
  firstNameKana: '',
  email: '',
  emailConfirm: '',
  tel: '',
  zipCode: '',
  pref: { id: 0, name: '未選択', cities: [] } as (Pref & { cities: City[] }),
  city: { id: 0, name: '------', prefId: 0 } as City,
  town: { id: 0, name: '------', zipCode: '', prefId: 0, cityId: 0 } as Town,
  address: '',
  shopsStatistics: [] as EstateCount[],
  password: '',
  hope: {
    pref: {id: 0, name: '------', cities: []} as (Pref & { cities: City[] }),
    cities: [
      {id: 0, name: '------', prefId: 0},
      {id: 0, name: '------', prefId: 0},
      {id: 0, name: '------', prefId: 0},
    ] as City[],
    estateType: {
      newEstatePrice: true,
      oldEstatePrice: true,
      newMansionPrice: true,
      oldMansionPrice: true,
      landPrice: true,
      businessPrice: true,
    },
    typeId: '03',
    newEstatePrice: [0, 999999] as [number, number] | null,
    oldEstatePrice: [0, 999999] as [number, number] | null,
    newMansionPrice: [0, 999999] as [number, number] | null,
    oldMansionPrice: [0, 999999] as [number, number] | null,
    landPrice: [0, 999999] as [number, number] | null,
    businessPrice: [0, 999999] as [number, number] | null,
    pushShinyabinFlag: true,
    newstellerFlag: true,
  },
};

const props = defineProps({
  encodedFcShopId: {
    type: String,
    required: false,
  },
  fcShopReferralCode: {
    type: String,
    required: false,
  },
  analyticsCode: {
    type: String,
    required: false,
  },
  prefId: {
    type: String,
    required: false,
  },
  cityId: {
    type: String,
    required: false,
  },
});
const setToolbarText: ((value: string) => void) | undefined = inject('setToolbarText');

const validForm = ref(false);
const helper = ref(false);
const form = reactive({
  ...defaultForm,
  hope: {
    ...defaultForm.hope,
    cities: [...defaultForm.hope.cities],
    pref: {...defaultForm.hope.pref},
  },
});

const breakPoint = useBreakpoint();
const router = useRouter();
const {rules} = useValidator();

const {prefectures} = useListPrefectures();
const {decodedShop} = useGetShopsByEncodedId(props.encodedFcShopId || '');
const {registerUser, registerUserLoading, registerUserError} = useUserRegister(props.encodedFcShopId);
const translateError = useErrorTranslate(registerUserError);
const {shopEstateStatistics, shopEstateStatisticsLoading} = useGetShopEstateStatistics({
  shopId: computed(() => String(decodedShop.value?.id || 0)),
  pref: computed(() => props.encodedFcShopId ? null : form.hope.pref),
  cities: computed(() => props.encodedFcShopId ? [] : form.hope.cities.map((item) => item)),
});

const hopePrefectures = computed(() => {
  if (!decodedShop.value) return prefectures.value;
  const shopValue = decodedShop.value;
  return prefectures.value.filter((item) => shopValue.area.prefectures.map(prefecture => prefecture.id)
      .includes(item.id));
});

function filterHopeCities(selectedCity: City) {
  // vir do Ds2
  if (decodedShop.value) {
    const shopValue = decodedShop.value;
    const cityIds = form.hope.cities.filter((item) => item.id !== selectedCity.id)
        .map((item) => item.id);
    return form.hope.pref.cities?.filter((item) =>
      shopValue.area.cities
        .filter(city => city.id === item.id && city.prefId === item.prefId)
        .filter(city => !cityIds.includes(city.id))
        .map(city => city.id)
        .includes(item.id)
    ) || []
  }
  const cityIds = form.hope.cities?.filter((item) => item.id !== selectedCity.id)
      .map((item) => item.id) || [];
  return form.hope.pref.cities?.filter((city) => !cityIds.includes(city.id)) || [];
}

function atLeastOnePriceSelected() {
  return Object.values(form.hope.estateType,)
      .some((item) => item) ? '' : 'この項目は必須です';
}

async function sendForm() {
  const address = form.town.name + form.address;
  if(!validForm.value) {
    forceValidate();
    return;
  }
  try {
    const registerResult = await registerUser({
      firstName: form.firstName,
      lastName: form.lastName,
      firstNameKana: form.firstNameKana,
      lastNameKana: form.lastNameKana,
      email: form.email,
      password: form.password,
      tel: form.tel,
      zipCode: form.zipCode,
      prefId: form.pref.id,
      cityId: form.city.id,
      address,
      fcShopIds: form.shopsStatistics.map(item => item.shopId),
      hope: {
        estateType: {
          newEstatePrice: form.hope.estateType.newEstatePrice,
          oldEstatePrice: form.hope.estateType.oldEstatePrice,
          newMansionPrice: form.hope.estateType.newMansionPrice,
          oldMansionPrice: form.hope.estateType.oldMansionPrice,
          landPrice: form.hope.estateType.landPrice,
          businessPrice: form.hope.estateType.businessPrice,
        },
        typeId: '03',
        newEstatePrice: form.hope.newEstatePrice || [0, 999999],
        oldEstatePrice: form.hope.oldEstatePrice || [0, 999999],
        newMansionPrice: form.hope.newMansionPrice || [0, 999999],
        oldMansionPrice: form.hope.oldMansionPrice || [0, 999999],
        landPrice: form.hope.landPrice || [0, 999999],
        businessPrice: form.hope.businessPrice || [0, 999999],
        pushShinyabinFlag: form.hope.pushShinyabinFlag,
        newstellerFlag: form.hope.newstellerFlag,
        prefId: form.hope.pref.id,
        cityIds: form.hope.cities.map((item) => item.id),
      },
    });
    const params: OptionalRegisterReferralOptions = {};
    if (props.analyticsCode) params.analyticsCode = props.analyticsCode;
    if (props.encodedFcShopId) params.encodedFcShopId = props.encodedFcShopId;
    if (props.fcShopReferralCode) params.fcShopReferralCode = props.fcShopReferralCode;
    await router.push({name: 'ConfirmEmail', query: {token: registerResult.confirmEmailToken, ...params}});
  } catch (e) {
    if ((e as ApiError).name === 'EmailInUseError') {
      alert(`入力されたメールアドレスはすでに登録されています。\n\n入力されたメールアドレスは、すでに登録されているためご利用いただけません。\n大変申し訳ございませんが、別のメールアドレスを入力してください。`);
    }
  }
}

function openHelp() {
  helper.value = !helper.value;
}

onUnmounted(async () => {
  if (setToolbarText) setToolbarText('');
});

watch(prefectures, () => {
  if (!props.prefId) return;
  const prefId = Number(props.prefId);
  const cityId = Number(props.cityId);
  form.hope.pref = prefectures.value.find((item) => item.id === prefId) || form.hope.pref;

  if (props.cityId) return;
  const city = form.hope.pref.cities.find((item) => item.id === cityId);
  if (city) form.hope.cities = [city, {id: 0, name: '------', prefId: 0}, {id: 0, name: '------', prefId: 0}];
});

watch(() => [decodedShop.value, prefectures.value], () => {
  if (decodedShop.value && prefectures.value.length) {
    const shopValue = decodedShop.value;
    // TODO Do not find prefecture by name
    const prefecture = prefectures.value.find((item) => item.name === shopValue.prefName) || form.hope.pref;
    // TODO Do not find city by name
    const city = prefecture.cities.find((item) => item.name === shopValue.cityName) || form.hope.cities[0];
    form.hope = {
      ...form.hope,
      pref: prefecture,
      cities: [city, defaultForm.hope.cities[1], defaultForm.hope.cities[2]],
    };
    if(decodedShop.value && decodedShop.value.personalGtmTag) {
      useAnalytics({
        tagManagerCode: decodedShop.value.personalGtmTag,
        hasCustomTagManager: true
      })
    }
    if(decodedShop.value && decodedShop.value.gtmTag){
      useAnalytics({tagManagerCode: decodedShop.value.gtmTag, hasCustomTagManager: true});
    }
  }
});
watch(() => form.hope.pref, () => {
  if (!props.encodedFcShopId) form.hope.cities = [...defaultForm.hope.cities];
}, {immediate: true, flush: 'post'});

watch(shopEstateStatistics, () => form.shopsStatistics = shopEstateStatistics.value);

</script>

<style scoped>
.container {
  max-width: 1000px;
  width: 100%;
}

.input-padding:deep(.input-container) {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.input-padding:deep(input) {
  margin-left: 8px;
}

.address-input {
  background: var(--lighterGray);
  border-right: 1px solid var(--border);
}
.icon-style {
  width: 30px !important;
  height: 30px !important;
  cursor: pointer;
}

.div-relative {
  position: relative !important;
}

.div-absolute {
  position: absolute !important;
}

.tip-content {
  -webkit-box-shadow: 0 0 3px #555;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 0 3px #555;
  color: #004680;
  font-size: 11px;
  text-align: left;
  width: 100%;
  bottom: calc(100% + 10px);
}

.tip-content:after,
.tip-content:before {
  top: 100%;
  left: 133px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.tip-content:before {
  border-top-color: #999;
  border-width: 8px;
  margin-left: -8px;
}

.tip-content:after {
  border-top-color: #fff;
  border-width: 7px;
  margin-left: -7px;
}

.question-btn {
  background-color: var(--primary);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
}

input:focus {
  transition: 2s;
}

.marginTop{
  margin-top: 30px;
}

.marginBottom {
  margin-bottom: 30px;
}

.titleMargins {
  font-size: 16px;
  border-bottom: 1px solid #004680;
  padding-bottom: 10px;
}


</style>
